import { useContext } from 'react';
import { DrivesContext } from '../context/drives.context';

export const useDrivesStores = () => {
    const context = useContext(DrivesContext);
    
    if (!context) {
        throw new Error('useDrivesStores must be used within a DrivesProvider');
    }
    
    return context;
};
